<template>
<div style="vertical-align: middle;" :style="{'min-height':minHeight, 'min-width':minWidth}">
  <!--/* 
    slotを用いて、Loadingコンポーネント＝親、loading後に見れる内容＝子、という関係にする。loading用変数の多重定義や、子から親へのイベントを減らすため。
    vueは親から子はreactiveだが、親が子内の変数を見る場合はreactiveではなく、イベントを経由しなければならない。 
    このためslotで親子関係を逆転させて、Loadingコンポーネントの変数が変更したら、ロード後の表示が見れるようにする。
  */-->
  <slot v-if="onceLoaded || !nowLoading" />

  <transition name="loading-fade">
    <div v-show="nowLoading && imgLoaded" style="text-align:center;">
      <img class="now-loading" :class="fadein?'fadein':''" :style="{'height':imgHeight, 'width':imgWidth, margin:margin, padding:padding}" src="@/assets/loading.png" @load="imgLoaded = true" />
    </div>
  </transition>
</div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";

@Options({
  props: {
    minHeight: {
      type: String,
    },
    minWidth: {
      type: String,
    },
    imgHeight: {
      default:"40px",
      type: String,
    },
    imgWidth: {
      default:"40px",
      type: String,
    },
    margin:{
      default:"",
      type: String,
    },
    padding:{
      default:"",
      type: String,
    },
    initialLoad: {
      default:true,
      type: Boolean,
    },
    enableOnScrollEnd:{
      default:false,
      type: Boolean,
    },
    scrollEndMargin:{
      default:100,
      type: Number,
    },
    fadein:{
      default:true,
      type: Boolean,
    }
  },
  emits:["onscrollend"]
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;

  private readonly initialLoad!: boolean;
  private readonly enableOnScrollEnd!:boolean;
  private readonly scrollEndMargin!:number;
  private readonly fadein!:boolean;
  private readonly margin!:string;
  private readonly padding!:string;


  private nowLoading = true;
  private imgLoaded = false;
  private onceLoaded = false;
  private isScrollEndReached = true;

  //親コンポーネントから呼び出し用
  public start(){
    this.nowLoading = true
  }
  public finish(){
    this.nowLoading = false
    this.onceLoaded = true
  }
  public setLoading(value:boolean){
    this.nowLoading = value
  }
  public isNowLoading(){
    return this.nowLoading
  }
  public enableNextScrollEnd(){
    this.isScrollEndReached = false
    
    //画面更新後に判定を行う
    this.$nextTick(()=>{
      this.onScroll()
    })
  }

  onScroll(){
    if(this.isScrollEndReached){
      return;
    }
    if((window.innerHeight + window.scrollY) + this.scrollEndMargin >= document.body.offsetHeight){
      this.isScrollEndReached = true;

      this.$emit("onscrollend")
    }
  }
  
  created(){
    this.nowLoading =this.initialLoad;
    if(this.enableOnScrollEnd){
      document.addEventListener('scroll', this.onScroll)
      //画面更新後に判定を行う
      this.$nextTick(()=>{
        this.onScroll()
      })
    }
  }

  beforeUnmount(){
    if(this.enableOnScrollEnd){
      document.removeEventListener('scroll', this.onScroll)
    }
  }

}
</script>

<style lang="scss" scoped>
.now-loading{
  border-radius: 50%;
  animation:spin 1.5s linear infinite;
  &.fadein{
    /* 表示には若干時間をかける*/
    animation:fadein 1s ease-in, spin 1.5s linear infinite;
  }
}
@keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

@keyframes fadein { 
  from { opacity: 0; }
  to   { opacity: 1; } 
}

/* 消える時に徐々に消す*/
.loading-fade-leave-active {
  transition: opacity 0.1s ease-out;
}

.loading-fade-leave-to {
  opacity: 0;
}
</style>
